import { render, staticRenderFns } from "./NuoxiaoerIndex.vue?vue&type=template&id=5e675794&scoped=true&"
import script from "./NuoxiaoerIndex.vue?vue&type=script&lang=ts&"
export * from "./NuoxiaoerIndex.vue?vue&type=script&lang=ts&"
import style0 from "./NuoxiaoerIndex.vue?vue&type=style&index=0&id=5e675794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e675794",
  null
  
)

export default component.exports